import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';
import { apiGetPage, apiEditInfo } from '../../request/api'

interface ManagementDetailProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface PageData {
    id: string;
    orderName: string;
    price: string;
    status: string;
    payType: string;
    created_at: string;
    applyInvoice_at: string;
    pay_at: string;
    invoicing_at: string;
    bankCardNumber: string;
    invoiceAddress: string;
    invoiceBank: string;
    invoiceHeader: string;
    invoiceIdentification: string;
    invoiceStatus: string;
    invoicePhone: string;
}

const ManagementDetail: React.FC<ManagementDetailProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [partList, setPartList] = useState<PageData>({
        id: '',
        orderName: '',
        price: '',
        status: '',
        payType: '',
        created_at: '',
        applyInvoice_at: '',
        pay_at: '',
        invoicing_at: '',
        bankCardNumber: '',
        invoiceAddress: '',
        invoiceBank: '',
        invoiceHeader: '',
        invoiceIdentification: '',
        invoiceStatus: '',
        invoicePhone: '',
    });

    const goback = () => {
        handleViewChange('management')
    }
    
    useEffect(() => {
        apiGetPage({
            tid: '4DCDCEA81A6C40618E5C121024774B64',
            page: 1,
            size: 1000,
            search: 'id=' + data
        }).then(res => {
            // setInvoiceList(res.data.data.rows)
            setPartList(res.data.data.rows[0])
            console.log(res.data.data.rows[0])
            console.log(partList);
        }).catch(err => {
            console.log(err)
        });
    }, []);
    return (
        <div className="CheckPayOrder">
            <div className='detail-back' style={{ color: themeColor }} onClick={goback}>
                <ArrowLeftOutlined />
                <div className='detail-back-right'> 返回 </div>
            </div>
            <p className='mine-h3'>服务信息</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>订单编号</p>
                    <p className='check-item-p'>{partList.id}</p>
                </div>
                <div className='check-item'>
                    <p>开票金额</p>
                    <p className='check-item-p'>{partList.price}</p>
                </div>
                <div className='check-item'>
                    <p>支付时间</p>
                    <p className='check-item-p'>{partList.pay_at}</p>
                </div>
            </div>
            <p className='mine-h3'>开票信息</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>开票抬头：</p>
                    <p className='check-item-p'>{partList.invoiceHeader}</p>
                </div>
                <div className='check-item'>
                    <p>纳税人识别号：</p>
                    <p className='check-item-p'>{partList.invoiceIdentification}</p>
                </div>
                <div className='check-item'>
                    <p>公司地址：</p>
                    <p className='check-item-p'>{partList.invoiceAddress}</p>
                </div>
                <div className='check-item'>
                    <p>联系电话：</p>
                    <p className='check-item-p'>{partList.invoicePhone}</p>
                </div>
            </div>
            <div className='check-order'>
                <div className='check-item'>
                    <p>开户行：</p>
                    <p className='check-item-p'>{partList.invoiceBank}</p>
                </div>
                <div className='check-item'>
                    <p>企业账号：</p>
                    <p className='check-item-p'>{partList.bankCardNumber}</p>
                </div>
                <div className='check-item'>
                    <p>申请开票时间：</p>
                    <p className='check-item-p'>{partList.applyInvoice_at}</p>
                </div>
            </div>
            {partList.invoiceStatus === '2' && <p className='mine-h3'>开票状态</p>}
            {partList.invoiceStatus === '2' &&
                <div className='check-order'>
                    <div className='kaipiao'>
                        <div className='kaipiao1'>已开票</div>
                        <DownloadOutlined style={{color:themeColor, fontSize:'30px'}} />
                    </div>
                    <div className='check-item'>
                        <p>开票时间</p>
                        <p className='check-item-p'>{partList.invoicing_at}</p>
                    </div>
                </div>
            }


        </div>
    );
};

export default ManagementDetail;